import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import InteractiveHero from './components/hero/InteractiveHero';
import PortfolioPage from './pages/PortfolioPage';
import AdminLogin from './admin/AdminLogin';
import AdminDashboard from './admin/AdminDashboard';
import SeoBoundary from './components/shared/SeoBoundary';
import CameraCursor from './components/shared/CameraCursor';
import './styles/portfolio.css';
import './App.css';

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <CameraCursor />
          <Routes>
            {/* Public routes */}
            <Route path="/" element={
              <>
                <SeoBoundary />
                <InteractiveHero />
              </>
            } />
            <Route path="/portfolio" element={
              <>
                <SeoBoundary />
                <PortfolioPage />
              </>
            } />

            {/* Admin routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
